import { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { reportView, urls } from '../../../../common/constants'
import moment from 'moment'
import * as urlValues from '../../oldReportsUrls'
import { connect } from 'react-redux'
import { appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { getDeliveryReportFilterData, getDeliveryReportTableData } from '../../../../../store/reports/reports_action'
import { ownDeliveryUpdatedColumn, OwnSummaryHeaderColumn } from '../constant'
import { updateAlert, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { useAtom, useSetAtom } from 'jotai'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
import { GetRequest } from '../../../../common/api'
import { globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { GT_COMPANY_ID, STA_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../../Reports/analysisReport/pdfAutotable'

const DeliveryOwnCompanyNew = (props) => {
    const { data, getDeliveryReportFilterData, getDeliveryReportTableData, updateAlertError, updateModal } = props
    const { common, reports } = data
    const { deliveryFilterData, deliveryTableData } = reports

    const [showReport, setShowReport] = useState(false)
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [sourceCityData, setSourceCityData] = useState([])
    const [sourceBranchData, setSourceBranchData] = useState([])
    const [sourceBranchUserData, setSourceBranchUserData] = useState([])
    const [paymentModeData, setPaymentModeData] = useState([])
    const [paymentTypeData, setPaymentTypeData] = useState([])
    const [sourceCity, setSourceCity] = useState(sourceCityData[0])
    const [sourceBranch, setSourceBranch] = useState(sourceBranchData[0])
    const [sourceBranchUser, setSourceBranchUser] = useState(sourceBranchUserData[0])
    const [paymentMode, setPaymentMode] = useState(paymentModeData[0])
    const [paymentType, setPaymentType] = useState(paymentTypeData[0])
    const [selReportView, setSelReportView] = useState(reportView?.[1])
    const [manageColumn, setManageColumn] = useState([])
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const setLoader = useSetAtom(globalLoaderAtom)
    const reportName = 'Delivery Report'
    const staDeliveryExtraFields = ['BookingNetAmount', 'ReceivingDate']
    const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
    const [ChildCompanyList] = useAtom(ChildCompanyListData)
    const [selCompany, setSelCompany] = useState(false)

    const [companySettings] = useAtom(companySettingsAtom)
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights, AllowGroupofCompanies } = { ...roleRightsData }
    const [searchParams] = useSearchParams()
    const allowFormatLR = companySettings?.allowFormatLR
    const UseToPayAsCOD = companySettings?.UseToPayAsCOD
    const DeliveryReportPortrait = companySettings?.DeliveryReportPortrait

    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = +searchParams.get('C') || 0
        loginData.intBranchCityID = +searchParams.get('CT') || 0
        loginData.strCityName = searchParams.get('CTN') || 0
        loginData.intUserID = +searchParams.get('U') || 0
        loginData.intBranchID = +searchParams.get('B') || 0
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        AllowViewAllBranchOfCityReport = searchParams.get('AllowViewAllBranchOfCityReport') || 0
        AllowViewAllBranchReport = searchParams.get('AllowViewAllBranchReport') || 0
        AllowBranchInchargeRights = searchParams.get('AllowBranchInchargeRights') || 0
        AllowGroupofCompanies = searchParams.get('AllowGroupofCompanies') || 0
        isFromUrl = true
    }
    let { DefaultCurrencyID } = companySettings
    if (!DefaultCurrencyID) {
        DefaultCurrencyID = +searchParams.get('DC') || 1
    }

    const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, strCityName, strUserName, IsBranchAdmin, strBranchName, IsMTPLAdmin } = loginData

    useEffect(() => {
        if (AllowGroupofCompanies === 1) {
            const defaultCompany =
                ChildCompanyList.find((v) => v.CompanyID === intCompanyID) ||
                ChildCompanyList[0];
            setSelCompany(defaultCompany);
        } else {
            setSelCompany({
                CompanyID: intCompanyID,
                CompanyName: strCompanyName
            });
        }
    }, [ChildCompanyList, AllowGroupofCompanies]);
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intCompanyID: intCompanyID,
                UserID: intUserID
            }
            fetchChildCompanyList(body)
        }
    }, [intUserID])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
 
    const groupedDetailedData = (arr = [], headers) => {
        const lengths = divideInNIntegers(headers.length, 3);
        let index = 0;
        const pickedHeaders = [];
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index]?.field);
            index += span;
        });
        const grouped = {};
        arr.forEach((val) => {
            const key = `${val.BranchName}-${val.PaymentType}-${val.PaymentModeName}`;
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(val);
        });
        const transform = (list) =>
            list.map((val, i) => ({
                ...val,
                SN: i + 1,
                'LRNO^^ManualLRNo': `${val.LRNO}\n${val.ManualLRNo}`,
                DelDateTime: `${moment(val.DeliveryDate).format("DD-MMM-YY")}\n${moment(val.DeliveryDate).format("HH:mm [Hrs]")}`,
                'SourceCity^^SourceBranch': `${val.SourceCity}\n${val.SourceBranch}`,
                'DispatchedByCity^^DispatchedByBranch': `${val.DispatchedByCity}\n${val.DispatchedByBranch}`,
                'Sender^^SenderMobileNo': `${val.Sender}\n${val.SenderMobileNo}`,
                'SenderGSTN^^SenderEmailID': `${val.SenderGSTN}\n${val.SenderEmailID}`,
                'RecName^^RecMobileNo': `${val.RecName}\n${val.RecMobileNo}`,
                'RecGSTN^^RecEmailID': `${val.RecGSTN}\n${val.RecEmailID}`,
                'DeliveredBy^^ItemDetails': `${val.DeliveredBy}\n${val.ItemDetails}`,
                Unit: `${val.Items}`,
                FrtChrge: `${val.Freight}`,
                KMFrtChrge: `${val.KMFreight}`,
                BkgOthChrge: `${val.BkgOtherCharges}`,
                DelCart: `${val.AdditionalDeliveryCartage}`,
                DelHam: `${val.HomeDeliveryChg}`,
                ExtHam: `${val.ExtraHamali}`,
                DemChrge: `${val.DemurrageChg}`,
                DelGST: `${val.DeliveryGST}`,
                DelDisc: `${val.DeliveryDisc}`,
                NetAmt: `${val.NetAmount}`,
                BookingNetAmount: `${val.BookingNetAmount ?? ''}`,
                ReceivingDate: val.ReceivingDate
                    ? `${moment(val.ReceivingDate).format("DD-MMM-YY")}\n${moment(val.ReceivingDate).format("HH:mm [Hrs]")}`
                    : '',
                dataType: 'entry',
            }));
        const summarize = (list) =>
            list.reduce(
                (acc, val) => {
                    acc.Unit += +val.Unit || 0;
                    acc.FrtChrge += +val.FrtChrge || 0;
                    acc.KMFrtChrge += +val.KMFrtChrge || 0;
                    acc.BkgOthChrge += +val.BkgOthChrge || 0;
                    acc.BookingNetAmount += +val.BookingNetAmount || 0;
                    acc.DelCart += +val.DelCart || 0;
                    acc.DelHam += +val.DelHam || 0;
                    acc.ExtHam += +val.ExtHam || 0;
                    acc.DemChrge += +val.DemChrge || 0;
                    acc.DelGST += +val.DelGST || 0;
                    acc.DelDisc += +val.DelDisc || 0;
                    acc.NetAmt += +val.NetAmt || 0;
                    return acc;
                },
                {
                    Unit: 0, FrtChrge: 0, KMFrtChrge: 0, BkgOthChrge: 0, BookingNetAmount: 0,
                    DelCart: 0, DelHam: 0, ExtHam: 0, DemChrge: 0,
                    DelGST: 0, DelDisc: 0, NetAmt: 0
                }
            );
        const finalData = [];
        const grandTotal = {
            Unit: 0, FrtChrge: 0, KMFrtChrge: 0, BkgOthChrge: 0, BookingNetAmount: 0,
            DelCart: 0, DelHam: 0, ExtHam: 0, DemChrge: 0,
            DelGST: 0, DelDisc: 0, NetAmt: 0
        };
        Object.entries(grouped).forEach(([key, list]) => {
            const [branch, paymentType, paymentModeName] = key.split("-");
            const transformed = transform(list);
            const summary = summarize(transformed);
            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] += summary[k] || 0;
            });
            finalData.push({
                colSpan: Object.fromEntries(
                    pickedHeaders.map((key, i) => [key, lengths[i] || 1])
                ),
                align: { [pickedHeaders[0]]: "left", [pickedHeaders[1]]: "left", [pickedHeaders[2]]: "right", },
                [pickedHeaders[0]]: `Branch: ${branch}`,
                [pickedHeaders[1]]: `Payment Type: ${paymentType}`,
                [pickedHeaders[2]]: `Payment Mode: ${paymentModeName}`,
                totalSubKey:3,
                dataType: "subHeader",
                totalSubKey:3,
            });
            finalData.push(...transformed);
            Object.keys(summary).forEach((k) => {
                summary[k] = Number(summary[k].toFixed(2));
            });
            finalData.push({
                ...summary,
                colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === "Unit") },
                [pickedHeaders[0]]: `Total: Branch ${branch}, Payment ${paymentType}, Mode ${paymentModeName}`,
                dataType: "total",
                align: { [pickedHeaders[0]]: "right" },
            });
        });
        if (Object.keys(grouped).length > 1) {
            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] = Number(grandTotal[k].toFixed(2));
            });
            const qtyIndex = headers.findIndex(h => h.field === "Unit");
            const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
            const firstHeader = headers[0]?.field;
            finalData.push({
                ...grandTotal,
                SN: `Grand Total: All Branches / All Payment Types / All Payment Modes`,
                dataType: "total",
                colSpan: { [firstHeader]: colSpanCount },
                align: {
                    [firstHeader]: "right",
                    [headers[colSpanCount]]: "right"
                }
            });
        }
        return finalData;
    };
    const applyStaDetailedColumns = (columns = []) => {
        const sanitizedColumns = columns.filter((col) => !staDeliveryExtraFields.includes(col.field))
        if (![STA_COMPANY_ID].includes(intCompanyID)) {
            return sanitizedColumns
        }
        const bookingNetAmountColumn = updatedColumn.find((col) => col.field === 'BookingNetAmount')
        const receivingDateColumn = updatedColumn.find((col) => col.field === 'ReceivingDate')
        const bookingOtherIndex = sanitizedColumns.findIndex((col) => col.field === 'BkgOthChrge')
        let orderedColumns = [...sanitizedColumns]

        if (bookingNetAmountColumn) {
            if (bookingOtherIndex === -1) {
                orderedColumns = [...orderedColumns, bookingNetAmountColumn]
            } else {
                orderedColumns = [
                    ...orderedColumns.slice(0, bookingOtherIndex + 1),
                    bookingNetAmountColumn,
                    ...orderedColumns.slice(bookingOtherIndex + 1)
                ]
            }
        }

        const deliveryDateIndex = orderedColumns.findIndex((col) => col.field === 'DelDateTime')
        if (!receivingDateColumn || deliveryDateIndex === -1) {
            return receivingDateColumn ? [...orderedColumns, receivingDateColumn] : orderedColumns
        }
        return [
            ...orderedColumns.slice(0, deliveryDateIndex),
            receivingDateColumn,
            ...orderedColumns.slice(deliveryDateIndex)
        ]
    }

    useEffect(() => {
        if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
            setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
            setDisableExcel(!(roleRightsData?.Table1?.[0]?.AllowExportExcel))            
        }
    }, [roleRightsData])
    useEffect(() => {
        if (deliveryFilterData?.Table?.length > 0) {
            const SourceCity = [...new Set(deliveryFilterData?.Table?.map((val) => ({ SourceCityName: val.CityName, SourceCityID: val.CityID }))),]
            const SourceBranch = [...new Set(deliveryFilterData?.Table?.map((val) => ({ SourceBranchName: val.BranchName, SourceBranchID: val.BranchID, SourceCityID: val.CityID }))),]
            const SourceBranchUser = [...new Set(deliveryFilterData?.Table?.map((val) => ({ UserName: val.UserName, UserID: val.UserID, SourceBranchID: val.BranchID }))),]
            const PaymentType = [...new Set(deliveryFilterData?.Table?.map((val) => ({ Name: val.PaymentTypeName, Id: val.PaymentTypeID }))),]
            const PaymentMode = [...new Set(deliveryFilterData?.Table?.map((val) => ({ Name: val.PaymentModeName, Id: val.PaymentMode }))),]
            const selectedCity = SourceCity?.filter((val) => val.SourceCityID === intBranchCityID)
            const selectedBranch = SourceBranch?.filter((val) => val.SourceBranchID === intBranchID)
            const selectedUser = SourceBranchUser?.filter((val) => val.UserID === intUserID)
            if (disableBtn) {
                setSourceCity({ SourceCityName: strCityName, SourceCityID: intBranchCityID })
            }
            if (disableBtn && AllowViewAllBranchOfCityReport == 0) {
                setSourceBranch({ SourceBranchName: strBranchName, SourceBranchID: intBranchID })
                // setSourceBranchUser({ UserName: strUserName, UserID: intUserID })
                setSourceBranchUser({ UserName: "All Branch User", UserID: 0 })
            } else {
                if (selectedCity?.length > 0) {
                    setSourceCity(selectedCity?.[0])
                } else {
                    setSourceCity({ SourceCityName: "All Cities", SourceCityID: 0 })
                }
                if (selectedBranch?.length > 0) {
                    setSourceBranch(selectedBranch?.[0])
                } else {
                    setSourceBranch({ SourceBranchName: "All Branch", SourceBranchID: 0 })
                }
                if (selectedUser?.length > 0) {
                    setSourceBranchUser(selectedUser?.[0])
                } else {
                    setSourceBranchUser({ UserName: "All Branch User", UserID: 0 })
                }
            }
            setPaymentType({ Name: "All", Id: 0 })
            setPaymentMode({ Name: "All", Id: 0 })
            setSourceCityData([{ SourceCityName: "All Cities", SourceCityID: 0 }, ...SourceCity])
            setSourceBranchData([{ SourceBranchName: "All Branch", SourceBranchID: 0 }, ...SourceBranch])
            setSourceBranchUserData([{ UserName: "All Branch User", UserID: 0 }, ...SourceBranchUser])
            setPaymentModeData([{ Name: "All", Id: 0 }, ...PaymentMode])
            setPaymentTypeData([{ Name: "All", Id: 0 }, ...PaymentType])
        } else {
            setSourceCityData([])
        }
    }, [deliveryFilterData])
    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        setSourceBranch(removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0])
    }
    const selectedSourceBranch = (obj) => {
        setShowReport(false)
        setSourceBranch(obj)
        setSourceBranchUser(removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter((val) => val?.SourceBranchID === obj?.SourceBranchID || obj?.SourceBranchID === 0 || val?.UserID === 0)?.[0])
    }


    const handleGoClick = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            const obj = {
                CompanyID: selCompany?.CompanyID,
                CurrBranchID: intBranchID,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                LoginUserID: intUserID
            }
            getDeliveryReportFilterData(obj)
            setSourceCity()
        }
    }
    const criteriaHeaders = [
        { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Delivery Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Delivery  Date', textAlign: 'left' },
        { field: 'sourceCity', header: 'Select City', textAlign: 'left' },
        { field: 'sourceBranch', header: 'Select Branch', textAlign: 'left' },
        { field: 'sourceBranchUser', header: 'Select Branch User', textAlign: 'left' },
        { field: 'paymentMode', header: 'Payment Mode', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
    ]
    const criteriaData = {
        selCompany: selCompany?.CompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        sourceCity: sourceCity?.SourceCityName || '',
        sourceBranch: sourceBranch?.SourceBranchName || '',
        sourceBranchUser: sourceBranchUser?.UserName || '',
        paymentMode: paymentMode?.Name || '',
        paymentType: paymentType?.Name || '',
        selReportView: selReportView?.ReportView || '',
        dataType: 'entry',
    }
    const handleClick1 = (isPdf = false) => {
        const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
        const isAllSelected = sourceCity?.SourceCityID === 0 || sourceBranch?.SourceBranchID === 0 || sourceBranchUser?.UserID === 0
        setShowReport(true)
        if (isAllSelected && diffDays > 15) {
            updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
        } else if (!isAllSelected && diffDays > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else if (sourceCity == '' || sourceCity == ' ') {
            updateAlertError({ show: true, msg: 'Select Source City', nextId: '' })
        } else if (sourceBranch == "" || sourceBranch == ' ') {
            updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' })
        } else if (sourceBranchUser == "" || sourceBranchUser == ' ') {
            updateAlertError({ show: true, msg: 'Select Branch User', nextId: '' })
        } else if (paymentType == '' || paymentType == ' ') {
            updateAlertError({ show: true, msg: 'Select Payment Type', nextId: '' })
        } else if (paymentMode == '' || paymentMode == ' ') {
            updateAlertError({ show: true, msg: 'Select Payment Mode', nextId: '' })
        } else {
            setLoader(true)
            const obj = {
                CompanyID: selCompany?.CompanyID,
                BranchID: sourceBranch?.SourceBranchID,
                CurrBranchID: intBranchID,
                UserID: sourceBranchUser?.UserID,
                CityID: sourceCity?.SourceCityID,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                PaymentType: paymentType?.Id,
                PaymentMode: paymentMode?.Id,
                LoginUserID: intUserID
            }
            GetRequest(urls.getDeliveryReportTableData, obj)
                .then((res) => {
                    setLoader(false)
                    if (res.status == 'Success') {
                        let reportData = []
                        let reportPayload = {}
                        let mainHeader = []
                        let deliveryTableData = res?.Data
                        if (selReportView?.ReportId == 0) {
                            if (deliveryTableData?.Table1?.length > 0) {

                                const data = deliveryTableData?.Table1?.map((val, i) => ({ ...val, SN: i + 1, PaymentType: UseToPayAsCOD === 1 && val.PaymentType === 'TOPAY' ? 'COD' : val.PaymentType === 'TOPAY(MANUAL)' ? 'COD(MANUAL)' : val.PaymentType, dataType: 'entry' }))

                                let TotalUnit = 0
                                let TotalFright = 0
                                let TotalKMFright = 0
                                let TotalBkgOthCharge = 0
                                let TotalDeliveryCartage = 0
                                let TotalDeliveryHamali = 0
                                let TotalExtraHamali = 0
                                let TotalDemurrageCharge = 0
                                let TotalDeliveryGST = 0
                                let TotalDelDiscount = 0
                                let TotalNetAmount = 0
                                data?.map((val) => {
                                    TotalUnit += Number(val.Items)
                                    TotalFright += Number(val.Freight)
                                    TotalKMFright += Number(val.KMFreight)
                                    TotalBkgOthCharge += Number(val.BkgOtherCharges)
                                    TotalDeliveryCartage += Number(val.DeliveryCartage)
                                    TotalDeliveryHamali += Number(val.DeliveryHamali)
                                    TotalExtraHamali += Number(val.ExtraHamali)
                                    TotalDemurrageCharge += Number(val.DemurrageChg)
                                    TotalDeliveryGST += Number(val.DeliveryGST)
                                    TotalDelDiscount += Number(val.DeliveryDisc)
                                    TotalNetAmount += Number(val.NetAmount)
                                })
                                data?.push({
                                    SN: 'Grand Total',
                                    Items: TotalUnit,
                                    Freight: TotalFright.toFixed(2),
                                    KMFreight: TotalKMFright.toFixed(2),
                                    BkgOtherCharges: TotalBkgOthCharge.toFixed(2),
                                    DeliveryCartage: TotalDeliveryCartage.toFixed(2),
                                    DeliveryHamali: TotalDeliveryHamali.toFixed(2),
                                    ExtraHamali: TotalExtraHamali.toFixed(2),
                                    DemurrageChg: TotalDemurrageCharge.toFixed(2),
                                    DeliveryGST: TotalDeliveryGST.toFixed(2),
                                    DeliveryDisc: TotalDelDiscount.toFixed(2),
                                    NetAmount: TotalNetAmount.toFixed(2),
                                    dataType: 'total',
                                })
                                reportData = [...data]
                            }
                            mainHeader = OwnSummaryHeaderColumn?.filter(col => DefaultCurrencyID !== 2 || col.field !== 'DeliveryGST').map((val) => (
                                {
                                    ...val,
                                    dataType: 'header',
                                    header: val.headerName,
                                    export: val.exportHead,
                                    weight: 80
                                }))
                            reportPayload = {
                                reportName: reportName + ' (Summary)',
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                serialNokey: 'SN',
                                showColumnBorders: true,
                            }
                            if (isPdf === true) {
                                downloadPDF({
                                    reportName: reportName + ' (Summary)',
                                    criteriaHeaders,
                                    criteriaData: [criteriaData],
                                    tableData: reportData,
                                    visibleColumns: mainHeader,
                                    loginData,
                                    showColumnBorders: true,
                                    hideHeader: false
                                })
                                return
                            }
                        } else {
                            if (deliveryTableData?.Table?.length > 0) {
                                let list = deliveryTableData?.Table || [];
                                if (UseToPayAsCOD === 1) {
                                    list = list.map((item) => {
                                        let newPaymentType = item.PaymentType;
                                        let newPaymentTypeID = item.PaymentTypeInt;
                                        if (item.PaymentTypeInt === 2) {
                                            newPaymentType = "COD";
                                        } else if (item.PaymentTypeInt === 7) {
                                            newPaymentType = "COD (MANUAL)";
                                        } else if (item.PaymentTypeInt === 9) {
                                            newPaymentType = "COD (DDDV)";
                                        }
                                        return { ...item, PaymentType: newPaymentType, PaymentTypeInt: newPaymentTypeID };
                                    });
                                }
                                const headers = manageColumn.filter((obj) => obj.isSelected);
                                const detailedData = groupedDetailedData(list, headers)
                                reportData = [...detailedData]
                            }
                            mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
                                ...val,
                                align: val.headerSx.textAlign,
                                export: val.exportHead,
                                weight: 80
                            }))
                            reportPayload = {
                                reportName: reportName + ' (Detailed)',
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                isShowManageColumn: true,
                                manageColumnID: 'updatedColumn12',
                                colSpanMarker: "DeliveredBy^^ItemDetails",
                                serialNokey :'SN',
                                showColumnBorders: true,
                                totalSubKey:3,
                            }
                            if (isPdf === true) {
                                downloadPDF({
                                    reportName: reportName + ' (Detailed)',
                                    criteriaHeaders,
                                    criteriaData: [criteriaData],
                                    tableData: reportData,
                                    visibleColumns: mainHeader,
                                    loginData,
                                    showColumnBorders: true,
                                    hideHeader: false
                                })
                                return
                            }
                        }
                        const rid = Date.now().toString()

                        if (!window.generatedReports) {
                            window.generatedReports = {}
                        }

                        window.generatedReports[rid] = reportPayload

                        window.open(`/view-report?rid=${rid}`, "_blank")
                    } else {
                        updateAlert({ show: true, msg: 'No Data Found' })
                    }
                })
                .catch((error) => {
                    setLoader(false)
                    updateAlert({ show: true, msg: error })
                })
        }
    }
    const handleClick2 = () => {
        if (paymentMode?.Id != 0) {
            updateAlertError({ show: true, msg: 'Only All Allowed in Payment Mode DropDown' })
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            let url = urlValues.deliveryReport
            let urlData = urlValues.deliveryReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.intCompanyID = intCompanyID
            urlData.intBranchID = sourceBranch?.SourceBranchID
            urlData.intUserID = sourceBranchUser?.UserID
            urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
            urlData.dtToDate = toDate.format('DD-MMM-YYYY')
            urlData.intPaymentType = paymentType?.Id
            urlData.PaymentType = paymentType?.Name
            urlData.BookedByBranch = sourceBranch?.SourceBranchID
            urlData.intAllowExportToExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }

    }
    const updatedColumn = ownDeliveryUpdatedColumn(allowFormatLR, DefaultCurrencyID, intCompanyID)
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }
        const updateColumnDetails = async () => {
            try {
                const localDetailedColumns = await getLocalData('updatedColumn12')
                let filnalcol = applyStaDetailedColumns(localDetailedColumns || updatedColumn)
                if (DeliveryReportPortrait === 1) {
                    filnalcol = filnalcol.filter((item) => item.isMandatory)
                }
                setManageColumn(filnalcol)
            } catch (error) {
                setManageColumn(applyStaDetailedColumns(updatedColumn))
                console.error(error)
            }
        }
        updateColumnDetails()
    }, [allowFormatLR, DefaultCurrencyID, DeliveryReportPortrait, intCompanyID])
    const onSaveColumns = (items) => {
        const updatedItems = applyStaDetailedColumns(items)
        setManageColumn(updatedItems)
        localStorage.setItem('updatedColumn12', JSON.stringify(updatedItems))
    }
    const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
    return (
        <>
            <Item sx={{ ...sx.reportFlex, justifyContent: 'start', paddingTop: "16px", paddingRight: '25px !important', gap: isFromUrl ? '15px' : '10px' }} className='reports'>
                {!isFromUrl && <Item sx={{ ...sx.itemsxGrow, width: '12%' }}>
                    <DropDownOA
                        id="selectCompnay"
                        prevId={'generateDiv'}
                        nextId={'ArrowForwardIosIcon1'}
                        label="Selected Company"
                        data={ChildCompanyList}
                        defaultvalue={selCompany?.CompanyName}
                        disabled={AllowGroupofCompanies === 1 ? false : true}
                        onSelect={(val) => setSelCompany(val)}
                        dataKey={`CompanyName`}
                        idKey={`CompanyID`}
                        width="100%"
                    />
                </Item>}
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        name={'from_date'}
                        label={`From Delivery Date`}
                        value={fromDate}
                        id={'fromDate'}
                        dateDiff={intCompanyID == 406 ? 1500 : 90}
                        dateChange={(date) => { setFromDate(date); focusElemnt('toDate') }}
                        width="100%"
                        nextId={'toDate'}
                        prevId={'DeliverySplitBtn'}
                    />
                </Item>
                <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            name={'to_date'}
                            label={'To Delivery  Date'}
                            id={'toDate'}
                            value={toDate}
                            dateChange={(date) => { setToDate(date); focusElemnt('deliveryGoBtn') }}
                            width="100%"
                            nextId={'deliveryGoBtn'}
                            prevId={'fromDate'}
                            dateDiff={intCompanyID == 406 ? 1500 : 90}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button id='deliveryGoBtn' onClick={handleGoClick} onKeyDown={(e) => navigation3(e, 'selectedCity', 'fromDate')} variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                            GO
                        </Button>
                    </Item>
                </Box>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        label={`Select City`}
                        id={'selectedCity'}
                        data={removeDuplicatesFromArray(sourceCityData, 'SourceCityID') || []}
                        disabled={disableBtn}
                        defaultvalue={sourceCity?.SourceCityName || sourceCity}
                        dataKey={`SourceCityName`}
                        idKey={`SourceCityID`}
                        onSelect={(val) => { selectedSourceCity(val) }}
                        width="100%"
                        nextId={'selectedBranch'}
                        prevId={'deliveryGoBtn'}
                    />
                </Item>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id={'selectedBranch'}
                        label={'Select Branch'}
                        disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
                        data={removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCityID === sourceCity?.SourceCityID || sourceCity?.SourceCityID === 0 || val.SourceBranchID === 0) || []}
                        defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
                        dataKey={`SourceBranchName`}
                        idKey={`SourceBranchID`}
                        onSelect={(val) => { selectedSourceBranch(val) }}
                        nextId={'selectUser'}
                        prevId={'selectedCity'}
                        width="100%"
                    />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                    <DropDownOA
                        id={'selectUser'}
                        label={'Select Branch User'}
                        defaultvalue={sourceBranchUser?.UserName || sourceBranchUser}
                        disabled={loginData?.intCompanyID === GT_COMPANY_ID ? false : disableBtn && AllowViewAllBranchOfCityReport == 0}
                        data={removeDuplicatesFromArray(sourceBranchUserData, 'UserID')?.filter((val) => val?.SourceBranchID === sourceBranch?.SourceBranchID || sourceBranch?.SourceBranchID === 0 || val?.UserID === 0) || []}
                        dataKey={`UserName`}
                        idKey={`UserID`}
                        onSelect={(obj) => { setShowReport(false); setSourceBranchUser(obj) }}
                        nextId={'paymentMode'}
                        prevId={'selectedBranch'}
                        width="100%"
                    />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                    <DropDownOA
                        id={'paymentMode'}
                        label={'Payment Mode'}
                        defaultvalue={paymentMode?.Name || paymentMode}
                        data={removeDuplicatesFromArray(paymentModeData, 'Id') || []}
                        onSelect={(val) => { setShowReport(false); setPaymentMode(val) }}
                        dataKey={`Name`}
                        idKey={`Id`}
                        nextId={'paymentType'}
                        prevId={'selectUser'}
                        width="100%"
                    />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                    <DropDownOA
                        id={'paymentType'}
                        label={'Payment Type'}
                        defaultvalue={paymentType?.Name || paymentType}
                        data={
                            removeDuplicatesFromArray(paymentTypeData, 'Id')?.map(item => {
                                if (UseToPayAsCOD === 1) {
                                    if (item.Id === 2) {
                                        return { ...item, Name: 'COD' };
                                    }
                                    if (item.Id === 7) {
                                        return { ...item, Name: 'COD Manual' };
                                    }
                                    if (item.Id === 9) {
                                        return { ...item, Name: 'COD DDDV' };
                                    }
                                    if (item.Id === 4) {
                                        return null;
                                    }
                                }
                                return item;
                            }).filter(Boolean)
                        }
                        onSelect={(val) => { setShowReport(false); setPaymentType(val) }}
                        dataKey={`Name`}
                        idKey={`Id`}
                        nextId={'ReportView'}
                        prevId={'paymentMode'}
                        width="100%"
                    />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                    <DropDownOA
                        id="ReportView"
                        label="Report View"
                        data={reportView}
                        defaultvalue={selReportView?.ReportView || ''}
                        onSelect={(val) => { setShowReport(false); setSelReportView(val) }}
                        idKey={`ReportId`}
                        dataKey={`ReportView`}
                        nextId={'DeliverySplitBtn'}
                        prevId={'paymentMode'}
                        width={isFromUrl ? '100%' : '170px'}
                    />
                </Item>
                {isFromUrl ?
                    <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'DeliverySplitBtn'}>
                        DOWNLOAD PDF
                    </Button> :
                    <>
                        <Item sx={sx.itemsx}
                            onKeyDown={(e) => navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'ReportView', () => handleClick1())}
                        >
                            <SplitButton
                                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                id1={'DeliverySplitBtn'}
                                prevID={'ReportView'}
                                onClick1={handleClick1}
                                onClick2={handleClick2}
                            />
                        </Item>
                        <Item sx={{ ...sx.itemsx, display: 'none' }}>
                            <RefreshSvg />
                        </Item>
                    </>}
            </Item>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getDeliveryReportFilterData, getDeliveryReportTableData, updateAlert, updateAlertError, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOwnCompanyNew)
